export const environment = {
  production: false,
  useMockData: false,
  apiUrl: 'https://glistening-vibrancy-production.up.railway.app/api'
};
